import { proxy } from 'valtio';

/**
 * Reactive state for tracking whether a value has been copied.
 * This is shared with SelectValueMenu
 */
export const copyState = proxy({
  isCopied: false,
});

/**
 * Sets the `isCopied` state.
 */
export function setIsCopied(value: boolean) {
  copyState.isCopied = value;
}
